/**
 * Created by psivanappans on 11/08/22
 * File: SingleTenantCDLDropDown
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body } from '@panwds/react-ui'
import { PlusCircleIcon } from '@panwds/icons'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { APP_ID_LOGGING_SERVICE } from '../../../../../common/constants/GlobalConstants'
import { ERROR_NO_CDL_INSTANCE_CSP } from '../../../../../common/constants/LabelConstants'
import { isNonemptyArray } from '../../../../../common/utils/Utils'
import { SASE_SELECT_CDL } from '../../../../constants/LabelConstants'
import SubscriptionService from '../../../../services/SubscriptionService'
import { ADD_NEW, SELECT_CDL } from '../../../constants/SubscriptionConstant'
import DropDown from '../../../dropdown/DropDown'
import { setActivateLoading } from '../../../../../common/reducers/actions/LicenseReducer.actions'

const SingleTenantCDLDropDown = (props) => {
  const {
    loading,
    selectedTSGInstances,
    globalTsgId,
    setPageError,
    dispatch,
    licenses,
  } = props
  const { clearErrors, watch, setValue, getValues } = useFormContext()
  const [cdlInstances, setCDLInstances] = useState([])
  const [cspId, setCSPId] = useState('')
  const [cdlDisabled, disableCDL] = useState(false)
  const [selectedCDL, setSelectedCDL] = useState('')
  const cspAccount = watch('support_account')
  const tsg_id = getValues('tsg')

  const isCdlLicenseAvailable = useMemo(() => {
    return licenses.find(each => each.app_id === APP_ID_LOGGING_SERVICE && !each?.is_csp_activated)
  }, [licenses])

  const updateCDLInstance = useCallback((disable, value = '') => {
    setSelectedCDL(value)
    setValue('cdl', value)
    disableCDL(disable)
  }, [setValue])

  const addOptionToCreateInstance = useCallback((cdlInstances = []) => {
    isCdlLicenseAvailable && cdlInstances.unshift({
      description: 'Create New Instance',
      value: 'Create New Instance',
      children: 'Create New Instance',
      desc: '',
      id: ADD_NEW,
      key: ADD_NEW,
      iconLeft: <PlusCircleIcon size='sm' className='cm-text-blue-600' />,
    })
  }, [isCdlLicenseAvailable])

  const getCDLinstances = useCallback(async (_cspId) => {
    if (!_cspId) {
      setCDLInstances([])
      updateCDLInstance(false)
      return
    }
    if (cspId !== _cspId) { //Skip for same accounts
      dispatch(setActivateLoading(true))
      setPageError('')
      const cdlInstance = selectedTSGInstances?.find(each => each.app_id === APP_ID_LOGGING_SERVICE)
      let instances = []
      if (cdlInstance) { //TSG has CDL instance
        const displayName = cdlInstance.tenant_display_name || cdlInstance.tenant_instance_name || cdlInstance.serial_number
        instances.push({ value: displayName, description: displayName, migrate: +false, id: cdlInstance.tenant_id })
      }
      else { //fetch standalone CDL instances
        try {
          const region = getValues('region_name') || null
          const { data } = await SubscriptionService.instancesFromCSP.get({ app_id: APP_ID_LOGGING_SERVICE, csp_id: _cspId, tsg_id: globalTsgId })
          instances = (isNonemptyArray(data)) ? data.map(each => ({
            migrate: +true,
            key: each.tenant_id,
            value: each.tenant_display_name,
            children: each.tenant_display_name,
            description: each.tenant_display_name,
            id: each.tenant_id,
            region: each.region,
            disabled: region?.id ? each.region !== region?.id : false
          })) : []
        }
        catch (error) {
          instances = [] //Empty instances in case of error.
        }
        addOptionToCreateInstance(instances)
      }
      if (!isNonemptyArray(instances) && Boolean(tsg_id?.id)) { //Hide error message for empty tenant
        setPageError(ERROR_NO_CDL_INSTANCE_CSP)
      }
      setCDLInstances(instances)
      const activeInstances = instances?.filter(x => !x.disabled)
      const selectCdlInstance = isNonemptyArray(activeInstances) && activeInstances.length === 1 ? activeInstances[0] : undefined
      updateCDLInstance(Boolean(selectCdlInstance), selectCdlInstance)
      clearErrors(['cdl'])
      dispatch(setActivateLoading(false))
    }
  }, [cspId, updateCDLInstance, dispatch, setPageError, selectedTSGInstances, tsg_id?.id, clearErrors, addOptionToCreateInstance, getValues, globalTsgId])

  useEffect(() => {
    getCDLinstances(cspAccount?.id)
    setCSPId(cspAccount?.id)
  }, [cspAccount?.id, getCDLinstances])

  return (<div>
    <DropDown
      addClassName='cmm-modal-select'
      itemList={cdlInstances}
      fieldName='cdl'
      label={<Body addClassName="tw-font-lato tw-italic" as="span">{SASE_SELECT_CDL}</Body>}
      height={null}
      width="100%"
      placeholderValue={selectedCDL ? null : SELECT_CDL}
      selectProps={{
        label: SASE_SELECT_CDL,
        showLabel: false,
        enableSearch: true,
        fullWidth: true,
        disabled: loading || cdlDisabled,
        selectedItem: selectedCDL,
      }}
    />
  </div>)
}

SingleTenantCDLDropDown.propTypes = {}
export default SingleTenantCDLDropDown
